import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useAppContext } from '../lib/AppContext';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription, SheetClose } from './ui/sheet';
import { Button } from './ui/button';

export default function AuthPromptSheet() {
  const { showAuthPrompt, closeAuthPrompt, endGuestSession, authPromptMessage } = useAppContext();
  const [, setLocation] = useLocation();

  const navigateHard = (path: string) => {
    try {
      setLocation(path);
    } catch {}
    // Fallback if SPA navigation fails
    setTimeout(() => {
      const currentPath = window.location.pathname + (window.location.search || '');
      if (currentPath !== path) {
        // Fallback navigation
        window.location.assign(path);
      }
    }, 50);
  };

  const goToAuth = (mode?: 'login' | 'register') => {
    closeAuthPrompt();
    // End guest session so /auth page is accessible
    try { endGuestSession(); } catch {}
    try {
      if (mode) sessionStorage.setItem('auth_mode', mode);
    } catch {}
    // Let the sheet close before navigating to avoid event conflicts
    setTimeout(() => {
      navigateHard('/auth');
    }, 0);
  };


  return (
    <Sheet open={showAuthPrompt} onOpenChange={(open) => !open && closeAuthPrompt()}>
      <SheetContent side="bottom" className="border-0 bg-transparent p-0">
        <div className="max-w-md mx-auto w-full -mb-12">
          <div className="rounded-t-3xl bg-white/95 backdrop-blur-md shadow-lg pt-6 pb-20">
            <SheetHeader>
              <SheetTitle className="text-center text-2xl bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">Welcome</SheetTitle>
              <SheetDescription className="text-center">{authPromptMessage}</SheetDescription>
            </SheetHeader>
            <div className="mt-6 flex flex-col gap-3 px-4">
              <SheetClose asChild>
                <Button className="w-full bg-gradient-to-r from-blue-600 to-blue-800 rounded-full" data-testid="signin-btn" onClick={() => goToAuth('login')}>
                  Sign In
                </Button>
              </SheetClose>
              <SheetClose asChild>
                <Button variant="outline" className="w-full rounded-full" data-testid="register-btn" onClick={() => goToAuth('register')}>
                  Create Account
                </Button>
              </SheetClose>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}


